export { StatusCode } from '@ps/web-core-api';

/**
 * @deprecated
 */
export enum StatusSubcode {
  AUTH_SUB_ERROR_NONE = 0,
  AUTH_SUB_AUTH_ERROR_ACCOUNT_CLOSED = 11,
  AUTH_SUB_ERROR_ACCOUNT_CLOSED_2 = 20
}
